import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import { HttpService } from "../../service/HttpService";
import PlantMapping from "../PlantMapping/PlantMapping";
import FertigationHistory from "../Fertigation/FertigationHistory/FertigationHistory";
import RoomLogMasterTable from "../../components/RoomLogMaster/RoomLogMasterTable";
import RoomLogArchive from "../../components/RoomLogMaster/RoomLogArchive";
import HarvestArchive from "../Harvest/HarvestArchive";
import COAReportArchive from "../COAReport/COAReportArchive";
import "./Archive.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeft } from "react-icons/fa";
import DryRoomArchive from "../DryRoom/DryRoomArchive";

const Archive = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { roomId, harvested_date } = location.state || {};
  const [roomTab, setRoomTab] = useState(0);
  const [contentTab, setContentTab] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [harvestedDate, setHarvestedDate] = useState("");

  useEffect(() => {
    if (rooms.length > 0 && roomId) {
      const roomIndex = rooms.findIndex((room) => room.id === roomId);
      if (roomIndex !== -1) {
        setRoomTab(roomIndex);
      }
    }
  }, [rooms, roomId]);

  useEffect(() => {
    if (harvested_date) {
      setHarvestedDate(harvested_date);
    }
  }, [harvested_date]);

  const httpService = new HttpService();

  const fetchRooms = async () => {
    setLoading(true);
    try {
      const res = await httpService.get("rooms?sortBy=name&sortOrder=ASC");
      const roomsData = res?.data?.data || [];
      const EXTRA_ROOMS = ["clone room", "mom room"];
      const filteredRooms = roomsData
        .filter((room) => {
          if (!room.name) return false;
          const name = room.name.trim().toLowerCase();
          const isNumberedRoom = /^room\s([1-9][0-9]?)$/.test(name);
          const isExtraRoom = EXTRA_ROOMS.includes(name);
          return isNumberedRoom || isExtraRoom;
        })
        .sort((a, b) => {
          const getNumber = (name) => {
            const match = name.match(/\d+/);
            return match ? Number(match[0]) : Infinity;
          };
          return getNumber(a.name) - getNumber(b.name);
        });
      setRooms(filteredRooms);
    } catch (e) {
      console.error("Error fetching rooms:", e);
      setRooms([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  const tabsSx = {
    backgroundColor: "#fffffc",
    "& .MuiTabs-indicator": {
      backgroundColor: "#00A272",
      height: "3px",
    },
    "& .MuiTab-root": {
      position: "relative",
      color: "#A1A2A1",
      fontWeight: 400,
      fontSize: "16px",
      textTransform: "none",
      padding: "12px 20px",
      marginRight: "8px",
      "&:not(.Mui-selected)::after": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: "3px",
        backgroundColor: "#C4C4C4",
      },
      "&.Mui-selected": {
        color: "#00A272 !important",
        fontWeight: 600,
        backgroundColor: "#E6F6F1",
        borderRadius: "4px 4px 0 0",
      },
    },
  };

  return (
    <div className="company">
      <div className="page-title">
        <div className="title-wrap d-flex align-items-center">
          <h3
            onClick={() => navigate(-1)}
            className="m-0"
            style={{ paddingRight: "12px", color: "#0000FF" }}
            role="button"
          >
            <span className="back">
              <FaArrowLeft />
            </span>
          </h3>
          <h1>Archive</h1>
        </div>
        <div
          className="title-wrap"
          style={{ color: "#0000FF", fontSize: "20px", fontWeight: 500 }}
        >
          Harvested Date : {harvestedDate}
        </div>
      </div>

      <div className="common_content">
        <Tabs
          value={roomTab}
          onChange={(e, newValue) => setRoomTab(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsSx, mb: 2 }}
        >
          {rooms.map((room) => (
            <Tab
              key={room.id}
              label={room.name}
              disabled={roomId && room.id !== roomId}
              sx={{
                "&.Mui-disabled": {
                  color: "#A1A2A1",
                  opacity: 0.5,
                },
              }}
            />
          ))}
        </Tabs>

        <Tabs
          value={contentTab}
          onChange={(e, newValue) => setContentTab(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsSx, mb: 3 }}
        >
          <Tab label="Planting" />
          <Tab label="Fertigation" />
          <Tab label="Room Log" />
          <Tab label="Dry Room" />
          <Tab label="Harvest" />
          <Tab label="COA" />
        </Tabs>

        {contentTab === 0 && rooms[roomTab] && (
          <PlantMapping
            key={`planting-${roomTab}`}
            roomId={rooms[roomTab]?.id}
            harvested={true}
          />
          // <div>Plating</div>
        )}
        {contentTab === 1 && rooms[roomTab] && (
          <FertigationHistory
            key={`fertigation-${roomTab}`}
            roomId={rooms[roomTab]?.id}
            harvested={true}
            harvestedDate={harvestedDate}
          />
          // <div>Fertigation</div>
        )}
        {contentTab === 2 && rooms[roomTab] && (
          <RoomLogArchive
            key={`roomlog-archive-${roomTab}`}
            roomId={rooms[roomTab]?.id}
            harvestedDate={harvestedDate}
          />
        )}
        {contentTab === 3 && rooms[roomTab] && (
          <DryRoomArchive
            key={`dryroom-archive-${roomTab}`}
            roomId={rooms[roomTab]?.id}
            harvestedDate={harvestedDate}
          />
        )}
        {contentTab === 4 && rooms[roomTab] && (
          <HarvestArchive
            key={`harvest-archive-${roomTab}`}
            roomId={rooms[roomTab]?.id}
            harvestedDate={harvestedDate}
          />
        )}
        {contentTab === 5 && rooms[roomTab] && (
          <COAReportArchive
            key={`coa-archive-${roomTab}`}
            roomId={rooms[roomTab]?.name}
            harvestedDate={harvestedDate}
          />
        )}
      </div>
    </div>
  );
};

export default Archive;
